const settings = {
  header: {
    height: 70,
  },
};

export default settings;
